var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30448 6.69732C5.30448 8.3381 5.97137 9.91168 7.15843 11.0719C8.3455 12.2321 9.9555 12.8839 11.6343 12.8839C13.313 12.8839 14.923 12.2321 16.1101 11.0719C17.2972 9.91168 17.9641 8.3381 17.9641 6.69732C17.9641 5.05654 17.2972 3.48296 16.1101 2.32275C14.923 1.16254 13.313 0.510742 11.6343 0.510742C9.9555 0.510742 8.3455 1.16254 7.15843 2.32275C5.97137 3.48296 5.30448 5.05654 5.30448 6.69732ZM20.6768 23.4895H1.68746C1.44763 23.4895 1.21763 23.3963 1.04805 23.2306C0.878473 23.0649 0.783203 22.8401 0.783203 22.6057V19.9543C0.783203 18.7823 1.25955 17.6583 2.10745 16.8296C2.95536 16.0009 4.10536 15.5353 5.30448 15.5353H17.9641C19.1632 15.5353 20.3132 16.0009 21.1611 16.8296C22.009 17.6583 22.4853 18.7823 22.4853 19.9543V22.6057C22.4853 22.8401 22.3901 23.0649 22.2205 23.2306C22.0509 23.3963 21.8209 23.4895 21.5811 23.4895H20.6768Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.2bdb98a57fab023da22b373966a28676.svg";
export { ForwardRef as ReactComponent };